<template>
  <form class="form" @submit.prevent="createUpdateProduitFiltration">
    <fieldset class="fieldset">
      <legend class="legend">
        <PhFunnel />
        <span>{{ produit.id ? 'Modifier' : 'Ajouter' }} un produit de filtration</span>
      </legend>

      <!-- Produit -->
      <div class="field">
        <label class="label" for="produit">Produit de filtration :</label>
        <select class="select" v-model="produit.produit_filtration" id="produit" required>
          <optgroup v-for="categorie in categories" :key="categorie.id" :label="categorie.nom">
            <option
              v-for="item in getProduitsByCategorie(categorie)"
              :key="item.id"
              :value="item.id"
            >
              {{ item.nom }}
            </option>
          </optgroup>
        </select>
      </div>

      <!-- Fabricant -->
      <div class="field">
        <label class="label" for="fabricant">Fabricant :</label>
        <select class="select" v-model="produit.fabricant" id="fabricant" required>
          <option v-for="fabricant in fabricants" :key="fabricant.id" :value="fabricant.id">
            {{ fabricant.nom }}
          </option>
        </select>
      </div>

      <!-- Numéro de lot -->
      <div class="field">
        <label class="label" for="numero_lot">Numéro de lot :</label>
        <input class="input" type="text" v-model="produit.numero_lot" id="numero_lot" required />
      </div>

      <!-- Numéro de semaine -->
      <div class="field">
        <label class="label" for="numero_semaine">Numéro de semaine :</label>
        <input
          class="input"
          type="number"
          min="1"
          max="52"
          v-model="produit.numero_semaine"
          id="numero_semaine"
          required
        />
      </div>

      <!-- DLUO -->
      <div class="field">
        <label class="label" for="dluo">DLUO :</label>
        <input
          class="input"
          type="date"
          v-model="produit.date_limite_utilisation_optimale"
          id="dluo"
          required
        />
      </div>
    </fieldset>

    <div class="buttons">
      <ButtonElement type="submit" color="success" :icon="PhCheck">Valider</ButtonElement>
    </div>
  </form>
</template>

<script setup lang="ts">
import { PhCheck, PhFunnel } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import type {
  OrdreFabricationGet,
  OrdreFabricationProduitFiltration,
} from '@/interfaces/OrdreFabrication.ts'
import type { PropType } from 'vue'
import type FabricantList from '@/interfaces/Fabricant.ts'
import type {
  ProduitFiltrationCategorie,
  ProduitFiltrationList,
} from '@/interfaces/ProduitFiltrationList.ts'

const showForm = defineModel<boolean>('showForm', { required: true })
const produit = defineModel<OrdreFabricationProduitFiltration>('produit', { required: true })
const ordreFabrication = defineModel<OrdreFabricationGet>('ordreFabrication', { required: true })

const props = defineProps({
  categories: {
    type: Array as PropType<ProduitFiltrationCategorie[]>,
    required: true,
  },
  fabricants: {
    type: Array as PropType<FabricantList[]>,
    required: true,
  },
  produits: {
    type: Array as PropType<ProduitFiltrationList[]>,
    required: true,
  },
})

function getProduitsByCategorie(categorie: ProduitFiltrationCategorie) {
  return props.produits.filter((item) => item.categorie_produit_filtration === categorie.id)
}

function createUpdateProduitFiltration() {
  // crée ou modifie un produit de filtration
  if (ordreFabrication.value.id) {
    // avec un OF existant
    // TODO
  } else {
    // avec un nouvel OF
    if (produit.value.id) {
      // avec un produit déjà existant
      const index = ordreFabrication.value.produits_filtration.indexOf(produit.value)
      ordreFabrication.value.produits_filtration.splice(index, 1, produit.value)
    } else {
      // avec un nouveau produit
      produit.value.id = crypto.randomUUID()
      ordreFabrication.value.produits_filtration.push(produit.value)
    }
  }
  // on masque le formulaire
  showForm.value = false
}
</script>
